import { Box, Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface SchoolTimetableStructuresEmptyStubProps {
  labelTextId: string;
  descriptionLabelTextId?: string;
  action: ReactNode;
  maxWidth?: number;
}

export const SchoolTimetableStructuresEmptyStub: FC<SchoolTimetableStructuresEmptyStubProps> = ({
  labelTextId,
  descriptionLabelTextId,
  action,
  maxWidth = 440,
}) => {
  const { $t } = useIntl();

  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <Typography textAlign="center" variant="h1" maxWidth={maxWidth}>
        {$t({ id: labelTextId })}
      </Typography>

      {descriptionLabelTextId && (
        <Typography textAlign="center" variant="h3" mt={1} maxWidth={440}>
          {$t({ id: descriptionLabelTextId })}
        </Typography>
      )}

      <Box mt={2.5}>{action}</Box>
    </Stack>
  );
};
